import { ref, onMounted, onBeforeUnmount } from "vue";

export function useOverflow(el) {
	const overflow = ref(false);

	let resizeObserver;

	onMounted(() => {
		resizeObserver = new ResizeObserver((entries) => {
			for (const entry of entries) {
				overflow.value = entry.target.scrollHeight > entry.target.clientHeight;
			}
		}).observe(el.value);
	});

	onBeforeUnmount(() => {
		if (resizeObserver)
			resizeObserver.unobserve(el.value);
	});

	return overflow;
}
